module.exports = __webpack_public_path__ + "d6d17448389eba3f671d33951504d591.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/climbs/climb_0.png
// module id = 1794
// module chunks = 1